module.exports = __webpack_public_path__ + "static/abilia-env1-33d34a82029faee1a411b2acdda45ce3.jpg";